export default function Logo() {
  return (
    <a href="/" className="flex items-center gap-2.5 select-none">
      <img src="/logo.png" alt="MarineLink" className="w-9 h-9 object-contain" />
      <span className="font-display text-[1.35rem] font-bold tracking-tight lowercase leading-none">
        <span className="text-[#0e4a6e] dark:text-white">marine</span>{' '}
        <span className="text-[#2ba9dc]">link</span>
      </span>
    </a>
  );
}
